export const userManagementTableColumns = {
  userName: {
    name: 'userName',
    field: 'userName',
    title: 'USER NAME',
    class: 'text',
    width: '25%',
  },
  email: {
    name: 'email',
    field: 'email',
    title: 'EMAIL',
    class: 'text',
    width: '25%',
  },
  phoneNumber: {
    name: 'phoneNumber',
    field: 'phoneNumber',
    title: 'PHONE NUMBER',
    class: 'text',
    width: '25%',
  },
  role: {
    name: 'role',
    field: 'role',
    title: 'Role',
    class: 'text',
    width: '20%',
  },
  action: {
    name: 'action',
    field: 'action',
    title: '',
    class: 'text',
    width: '5%',
  },
};
export const pendingUserManagementTableColumns = {
  email: {
    name: 'email',
    field: 'email',
    title: 'EMAIL',
    class: 'text',
    width: '25%',
  },
  date: {
    name: 'date',
    field: 'date',
    title: 'CREATION DATE',
    class: 'text',
    width: '25%',
  },
  action: {
    name: 'action',
    field: 'action',
    title: '',
    class: 'text',
    width: '10%',
  },
};
export const technologiesTableCategories = {
  technology: {
    name: 'technology',
    field: 'technology',
    title: 'Technology',
    class: 'text',
    height: '33%',
  },
  amount: {
    name: 'amount',
    field: 'amount',
    title: 'Number of assets using',
    class: 'text',
    height: '33%',
  },
  exploitable: {
    name: 'exploitable',
    field: 'exploitable',
    title: 'Exploitable or not',
    class: 'text',
    height: '33%',
  },
};

export const cloudInstancesTabTableColumns = {
  select: {
    name: 'select',
    field: 'select',
    title: '',
    class: 'text cloud-url',
    width: '40px',
  },
  actions: {
    name: 'actions',
    field: 'actions',
    title: '',
    class: 'text cloud-url',
    width: '50px',
  },
  url: {
    name: 'url',
    field: 'url',
    title: 'URL',
    class: 'text cloud-url',
    minWidth: 620,
  },
  status: {
    name: 'status',
    field: 'status',
    title: 'STATUS',
    class: 'text cloud-status',
    width: '100px',
  },
  ports: {
    name: 'ports',
    field: 'ports',
    title: 'PORTS',
    class: 'text cloud-ports',
    width: '550px',
  },
  alert: {
    name: 'alert',
    field: 'alert',
    title: 'ALERT',
    class: 'text',
    width: '200px',
  },
  activeMonitoring: {
    name: 'activeMonitoring',
    field: 'activeMonitoring',
    title: 'ACTIVE MONITORING',
    class: 'text',
    width: '230px',
  },
  interval: {
    name: 'interval',
    field: 'interval',
    title: 'INTERVAL',
    class: 'text',
    width: '200',
  },
  action: {
    name: 'action',
    field: 'action',
    title: 'ACTION',
    class: 'text',
    width: '170px',
  },
};

export const technologiesTabTableColumns = {
  technology: {
    name: 'technology',
    field: 'name',
    title: 'technologyTabTable.technology',
    sortingField: 'technology',
    class: 'text',
    width: '15%',
    sortable: true,
  },
  version: {
    name: 'version',
    field: 'versions',
    title: 'technologyTabTable.version',
    class: 'text',
    width: '15%',
  },
  assets: {
    name: 'assets',
    field: 'assetsAmount',
    title: 'technologyTabTable.assets',
    sortingField: 'assets',
    class: 'text',
    width: '15%',
    sortable: true,
  },
  existsExploits: {
    name: 'existsExploits',
    field: 'vulnerable',
    title: 'technologyTabTable.exploit.exists',
    class: 'text',
    width: '15%',
  },
  cves: {
    name: 'cves',
    field: 'cves',
    title: 'technologyTabTable.cves',
    sortingField: 'cves',
    class: 'text',
    width: '15%',
    sortable: true,
  },
  validated: {
    name: 'validated',
    field: 'validated',
    title: 'technologyTabTable.validation.triggered',
    sortingField: 'validated',
    class: 'text',
    width: '25%',
    sortable: true,
  },
  action: {
    name: 'action',
    field: 'action',
    title: '',
    class: 'text',
    width: '',
  },
};

export const bucketsTabTableColumns = {
  select: {
    name: 'select',
    field: 'select',
    title: '',
    class: 'text bucket-select',
    width: '30px',
  },
  actions: {
    name: 'actions',
    field: 'actions',
    title: '',
    class: 'text bucket-actions',
    width: '20px',
  },
  url: {
    name: 'url',
    field: 'url',
    title: 'CLOUD',
    class: 'text',
    width: '80%',
  },
  status: {
    name: 'status',
    field: 'status',
    title: 'STATUS',
    class: 'text',
    width: '20%',
  },
};

export const servicesDescriptionTabTableColumns = {
  description: {
    name: 'description',
    field: 'description',
    title: 'servicesDescriptionTabTable.description',
    class: 'text',
    width: '0%',
  },
  severity: {
    name: 'severity',
    field: 'severity',
    title: 'servicesDescriptionTabTable.severity',
    class: 'text',
    width: '0%',
  },
  assets: {
    name: 'assets',
    field: 'assets',
    title: 'servicesDescriptionTabTable.assets',
    class: 'text',
    width: '0%',
  },
  status: {
    name: 'status',
    field: 'status',
    title: 'servicesDescriptionTabTable.status',
    class: 'text',
    width: '0%',
  },
};

export const servicesDescriptionPopupTableColumns = {
  resourceType: {
    name: 'resourceType',
    field: 'resourceType',
    title: 'servicesDescriptionPopupTable.resource.type',
    class: 'text',
    width: '30%',
  },
  resourceId: {
    name: 'resourceId',
    field: 'resourceId',
    title: 'servicesDescriptionPopupTable.resource.id',
    class: 'text',
    width: '25%',
  },
  resourceArn: {
    name: 'resourceArn',
    field: 'resourceArn',
    title: 'servicesDescriptionPopupTable.resource.arn',
    class: 'text',
    width: '35%',
  },
};

export const serviceProviderConfigurationColumns = {
  userName: {
    name: 'userName',
    field: 'userName',
    title: 'serviceProviderConfigurationTable.userName',
    class: 'text',
    width: '20%',
  },
  id: {
    name: 'id',
    field: 'id',
    title: 'serviceProviderConfigurationTable.id',
    class: 'text',
    width: '5%',
  },
  email: {
    name: 'email',
    field: 'email',
    title: 'serviceProviderConfigurationTable.email',
    class: 'text',
    sortable: true,
    width: '20%',
  },
  phoneNumber: {
    name: 'phoneNumber',
    field: 'phoneNumber',
    title: 'serviceProviderConfigurationTable.phoneNumber',
    class: 'text',
    width: '20%',
    sortable: true,
  },
  role: {
    name: 'role',
    field: 'role',
    title: 'serviceProviderConfigurationTable.role',
    class: 'text',
    width: '20%',
    sortable: true,
  },
  actions: {
    name: 'actions',
    field: 'actions',
    title: 'serviceProviderConfigurationTable.actions',
    class: 'text',
    width: '5%',
    sortable: true,
  },
};

export const cvesDataColumns = {
  version: {
    name: 'version',
    field: 'version',
    title: 'VERSION',
    class: 'text',
    width: '150px',
  },
  cve: {
    name: 'cve',
    field: 'cve',
    title: 'CVE',
    class: 'text',
    width: '200px',
  },
  cvss: {
    name: 'cvss',
    field: 'cvss',
    title: 'CVSS SCORE',
    class: 'text',
    width: '100px',
  },
  trendy: {
    name: 'trendy',
    field: 'trendy',
    title: 'TREND',
    class: 'text',
    width: '90px',
  },
};

export const leaksDataColumns = {
  mark: {
    name: 'mark',
    field: 'mark',
    title: 'leaksDataTable.mark',
    class: 'text',
    width: '4%',
  },
  leakType: {
    name: 'leakType',
    field: 'leakType',
    title: 'leaksDataTable.type',
    class: 'text',
    width: '25%',
  },
  content: {
    name: 'content',
    field: 'content',
    title: 'leaksDataTable.content',
    class: 'text',
    width: '5%',
  },
  source: {
    name: 'source',
    field: 'source',
    title: 'leaksDataTable.source',
    sortingField: 'source',
    class: 'text',
    width: '10%',
    sortable: true,
  },
  committer: {
    name: 'committer',
    field: 'committer',
    title: 'leaksDataTable.committer',
    class: 'text',
    width: '14%',
  },
  leakUrl: {
    name: 'leakUrl',
    field: 'leakUrl',
    title: 'leaksDataTable.url',
    class: 'text',
    width: '21%',
  },
  reviewed: {
    name: 'reviewed',
    field: 'reviewed',
    title: 'leaksDataTable.reviewed',
    width: '7%',
    class: 'text',
  },
  keyword: {
    name: 'keyword',
    field: 'keyword',
    title: 'leaksDataTable.keyword',
    width: '10%',
    class: 'text',
  },
};
export const authenticationObjectsColumns = {
  name: {
    name: 'name',
    field: 'name',
    title: 'authenticationObjectsTable.name',
    class: 'text',
    width: '10%',
    sortable: false,
  },
  description: {
    name: 'description',
    field: 'description',
    title: 'authenticationObjectsTable.description',
    class: 'text',
    width: '50%',
    sortable: false,
  },
  type: {
    name: 'type',
    field: 'type',
    title: 'authenticationObjectsTable.type',
    class: 'text',
    width: '10%',
    sortable: false,
  },
  icon: {
    name: 'icon',
    field: 'icon',
    title: '',
    class: 'text',
    width: '2%',
  },
  actions: {
    name: 'actions',
    field: 'actions',
    title: '',
    class: 'text',
    width: '10%',
  },
};
export const apiKeysColumns = {
  user: {
    name: 'user',
    field: 'user',
    title: 'apiKeyTable.user',
    class: 'text',
    width: '10%',
    sortable: false,
  },
  description: {
    name: 'description',
    field: 'description',
    title: 'apiKeyTable.description',
    class: 'text',
    width: '48%',
    sortable: false,
  },
  expiration: {
    name: 'expiration',
    field: 'expiration',
    title: 'apiKeyTable.expiration',
    class: 'text',
    width: '10%',
    sortable: false,
  },
  createdDate: {
    name: 'createdDate',
    field: 'createdDate',
    title: 'apiKeyTable.createdDate',
    class: 'text',
    width: '12%',
    sortable: false,
  },
  icon: {
    name: 'icon',
    field: 'icon',
    title: '',
    class: 'text',
    width: '2%',
  },
  actions: {
    name: 'actions',
    field: 'actions',
    title: '',
    class: 'text',
    width: '10%',
  },
};
export const integrationsColumns = {
  date: {
    name: 'date',
    field: 'date',
    title: 'integrationsTable.date',
    class: 'text',
    sortingField: 'createdDate',
    width: '20%',
    sortable: true,
  },
  name: {
    name: 'displayName',
    field: 'displayName',
    title: 'integrationsTable.name',
    class: 'text',
    width: '30%',
    sortingField: 'metaData.displayName',
    sortable: true,
  },
  category: {
    name: 'category',
    field: 'category',
    title: 'integrationsTable.category',
    class: 'text',
    width: '30%',
    sortingField: 'category',
    sortable: true,
  },
  icon: {
    name: 'icon',
    field: 'icon',
    title: '',
    class: 'text',
    width: '10%',
  },
  actions: {
    name: 'actions',
    field: 'actions',
    title: '',
    class: 'text',
    width: '10%',
  },
};

export const reportsColumns = {
  date: {
    name: 'date',
    field: 'date',
    title: 'reportsTable.date',
    class: 'text',
    sortingField: 'date',
    width: '20%',
    sortable: true,
  },
  tld: {
    name: 'tld',
    field: 'tld',
    title: 'reportsTable.tld',
    class: 'text',
    width: '20%',
    sortingField: 'tld',
    sortable: true,
  },
  type: {
    name: 'type',
    field: 'type',
    title: 'reportsTable.type',
    class: 'text',
    width: '20%',
    sortingField: 'type',
    sortable: true,
  },
  source: {
    name: 'source',
    field: 'source',
    title: 'reportsTable.source',
    class: 'text',
    width: '20%',
    sortingField: 'source',
    sortable: true,
  },
  icon: {
    name: 'icon',
    field: 'icon',
    title: 'reportsTable.report',
    class: 'text',
    width: '5%',
  },
};

export const issuesMainLayoutColumns = {
  date: {
    name: 'date',
    field: 'date',
    title: 'issuesTable.date',
    class: 'text',
    sortingField: 'createdDate',
    width: '140px',
    sortable: true,
  },
  name: {
    name: 'name',
    field: 'displayName',
    title: 'issuesTable.name',
    class: 'text',
    width: '20%',
    sortingField: 'displayName',
    sortable: true,
  },
  tld: {
    name: 'tld',
    field: 'tld',
    title: 'issuesTable.tld',
    class: 'text',
    width: '12%',
    sortingField: 'tld',
    sortable: true,
  },
  asset: {
    name: 'asset',
    field: 'asset',
    title: 'issuesTable.asset',
    class: 'text',
    width: '15%',
    sortingField: 'asset',
    sortable: true,
  },
  cycles: {
    name: 'cycles',
    field: 'cycles',
    title: 'issuesTable.cycles',
    class: 'text cycles',
    sortingField: 'issueCount',
    sortable: true,
    width: '5%',
  },
  priority: {
    name: 'priority',
    field: 'priority',
    title: 'issuesTable.priority',
    class: 'text priority',
    sortingField: 'priority',
    sortable: true,
    width: '6%',
  },
  firstSeen: {
    name: 'firstSeen',
    field: 'firstSeen',
    title: 'issuesTable.firstSeen',
    class: 'text firstSeen',
    sortingField: 'firstDate',
    sortable: true,
    width: '7%',
  },
  lastSeen: {
    name: 'lastSeen',
    field: 'lastSeen',
    title: 'issuesTable.lastSeen',
    class: 'text lastSeen',
    sortingField: 'lastDate',
    sortable: true,
    width: '7%',
  },
  description: {
    name: 'description',
    field: 'description',
    title: 'issuesTable.description',
    class: 'text description',
    width: '300px',
  },
  severity: {
    name: 'severity',
    field: 'severity',
    title: 'issuesTable.severity',
    class: 'text severity',
    sortingField: 'severity',
    width: '7%',
    sortable: true,
  },
  exploitability: {
    name: 'exploitability',
    field: 'exploitability',
    title: 'issuesTable.exploitability',
    class: 'text exploitability',
    sortingField: 'exploitability',
    width: '7%',
    sortable: true,
  },
  probability: {
    name: 'probability',
    field: 'probability',
    title: 'issuesTable.probability',
    class: 'text probability',
    width: '120px',
    sortingField: 'probability',
    sortable: true,
  },
  source: {
    name: 'source',
    field: 'source',
    title: 'issuesTable.source',
    class: 'text source',
    width: '13%',
    sortingField: 'source',
    sortable: true,
  },
  status: {
    name: 'status',
    field: 'status',
    title: 'issuesTable.status',
    class: 'text status',
    width: '5%',
    sortingField: 'status',
    sortable: true,
  },
  actions: {
    name: 'actions',
    field: 'actions',
    title: '',
    class: 'text',
    width: '0px',
    sortable: false,
  },
};

export const projectsColumns = {
  id: {
    name: 'projectId',
    field: 'id',
    title: 'projectsTable.id',
    class: 'text',
    width: '100px',
  },
  projectNumber: {
    name: 'projectNumber',
    field: 'projectNumber',
    title: 'projectsTable.projectNumber',
    class: 'text',
    width: '100px',
  },
  name: {
    name: 'projectName',
    field: 'name',
    title: 'projectsTable.name',
    class: 'text',
    minWidth: 170,
    sortable: true,
  },
  bundle: {
    name: 'projectBundle',
    field: 'formattedBundle',
    sortingField: 'bundle',
    title: 'projectsTable.bundle',
    class: 'text',
    minWidth: 90,
    sortable: true,
  },
  provider: {
    name: 'projectProvider',
    field: 'serviceProviderWorker',
    title: 'projectsTable.serviceProviderWorker',
    class: 'text',
    minWidth: 180,
    sortable: false,
  },
  customer: {
    name: 'projectCustomer',
    field: 'customer',
    title: 'projectsTable.customer',
    class: 'text',
    minWidth: 180,
    sortable: false,
  },
  start: {
    name: 'projectStart',
    field: 'formattedStartDate',
    title: 'projectsTable.startDate',
    sortingField: 'startDate',
    class: 'date',
    width: '150px',
    sortable: true,
  },
  end: {
    name: 'projectEnd',
    field: 'formattedEndDate',
    title: 'projectsTable.endDate',
    sortingField: 'endDate',
    class: 'date',
    width: '150px',
    sortable: true,
  },
  budget: {
    name: 'projectBudget',
    field: 'formattedBudget',
    sortingField: 'budget',
    title: 'projectsTable.budget',
    class: 'text',
    width: '150px',
    sortable: true,
  },
  status: {
    name: 'projectStatus',
    field: 'status',
    title: 'projectsTable.status',
    class: 'text',
    width: '100px',
    sortable: true,
  },
  progress: {
    name: 'projectProgress',
    field: 'progress',
    title: 'projectsTable.progress',
    class: 'text',
    width: '90px',
    sortable: true,
  },
  issuesCount: {
    name: 'projectIssuesCount',
    field: 'issuesCount',
    title: '',
    class: 'text',
    width: '0%',
    sortable: false,
  },
};

export const activityLogColumns = {
  actions: {
    name: 'actions',
    field: 'actions',
    title: '',
    class: 'text',
    width: '50px',
  },
  id: {
    name: 'id',
    field: 'id',
    title: 'activityLogTable.id',
    class: 'text',
    width: '100px',
  },
  number: {
    name: 'number',
    field: 'projectNumber',
    title: 'activityLogTable.number',
    class: 'text',
    width: '100px',
  },
  asset: {
    name: 'asset',
    field: 'asset',
    sortingField: 'testCard.url',
    title: 'activityLogTable.asset',
    class: 'text',
    minWidth: 300,
    sortable: true,
  },
  activity: {
    name: 'activity',
    field: 'activity',
    sortingField: 'testCard.type',
    title: 'activityLogTable.activity',
    class: 'text',
    minWidth: 200,
    sortable: true,
  },
  type: {
    name: 'type',
    field: 'formattedType',
    sortingField: 'testCard.frequency',
    title: 'activityLogTable.type',
    class: 'text',
    minWidth: 200,
    sortable: true,
  },
  startDate: {
    name: 'startDate',
    field: 'formattedStartDate',
    title: 'activityLogTable.startDate',
    sortingField: 'createdDate',
    class: 'date',
    width: '200px',
    sortable: true,
  },
  endDate: {
    name: 'endDate',
    field: 'formattedEndDate',
    title: 'activityLogTable.endDate',
    sortingField: 'endDate',
    class: 'date',
    width: '200px',
    sortable: true,
  },
  duration: {
    name: 'duration',
    field: 'duration',
    title: 'activityLogTable.duration',
    class: 'text',
    width: '200px',
    sortable: false,
  },
  status: {
    name: 'status',
    field: 'status',
    title: 'activityLogTable.status',
    class: 'text',
    width: '100px',
    sortable: true,
  },
  progress: {
    name: 'progress',
    field: 'progress',
    title: 'activityLogTable.progress',
    class: 'text',
    width: '130px',
    sortable: true,
  },
  issuesCount: {
    name: 'issuesCount',
    field: 'issuesCount',
    title: '',
    class: 'text',
    width: '0px',
    sortable: false,
  },
};

export const scanDataColumns = {
  date: {
    name: 'scanDate',
    field: 'date',
    title: 'scanDataTable.date',
    class: 'date',
    width: '70%',
    sortable: true,
  },
  export: {
    name: 'exportReport',
    field: 'export',
    title: 'scanDataTable.download',
    class: 'text',
    minWidth: 150,
  },
};

export const requestsColumns = {
  projectNumber: {
    name: 'projectNumber',
    field: 'projectNumber',
    title: 'requestsTable.projectNumber',
    class: 'text',
    width: '100px',
  },
  projectType: {
    name: 'projectType',
    field: 'formattedType',
    title: 'requestsTable.type',
    sortingField: 'project.type',
    class: 'text',
    minWidth: 180,
    sortable: true,
  },
  projectStart: {
    name: 'projectStart',
    field: 'formattedStartDate',
    title: 'requestsTable.start',
    sortingField: 'project.startDate',
    class: 'date',
    minWidth: 90,
    sortable: true,
  },
  projectEnd: {
    name: 'projectEnd',
    field: 'formattedEndDate',
    title: 'requestsTable.end',
    sortingField: 'project.endDate',
    class: 'date',
    minWidth: 100,
    sortable: true,
  },
  projectBudget: {
    name: 'projectBudget',
    field: 'formattedBudget',
    title: 'requestsTable.budget',
    sortingField: 'project.budget',
    class: 'text',
    minWidth: 90,
    sortable: true,
  },
  declineApprove: {
    name: 'declineApprove',
    class: 'text',
    minWidth: 180,
    sortable: false,
  },
};

export const issueColumns = {
  securityRisk: {
    name: 'securityRisk',
    field: 'securityRisk',
    title: 'projectDetails.issues.securityRisk',
    class: 'text security-risk',
    maxWidth: 500,
    minWidth: 250,
  },
  description: {
    name: 'description',
    field: 'description',
    title: 'projectDetails.issues.description',
    class: 'text description',
    minWidth: 352,
  },
  probability: {
    name: 'probability',
    field: 'probability',
    title: 'projectDetails.issues.probability',
    class: 'text probability',
    width: '120px',
    minWidth: 120,
  },
  severity: {
    name: 'severity',
    field: 'severity',
    title: 'projectDetails.issues.severity',
    class: 'text severity',
    width: '108px',
    minWidth: 108,
  },
  riskScore: {
    name: 'riskScore',
    field: 'riskScore',
    title: 'projectDetails.issues.riskScore',
    class: 'text risk-score',
    width: '115px',
    minWidth: 115,
  },
  status: {
    name: 'status',
    field: 'status',
    title: 'projectDetails.issues.status',
    class: 'text status',
    width: '52px',
    minWidth: 52,
  },
};

export const automaticProjectIssueColumns = {
  validate: {
    name: 'validated',
    field: 'validated',
    title: 'projectDetails.issues.validated',
    class: 'text validated',
    width: '5%',
  },
  name: {
    name: 'name',
    field: 'name',
    title: 'projectDetails.issues.name',
    class: 'text',
    width: '23%',
    sortable: true,
  },
  description: {
    name: 'description',
    field: 'description',
    title: 'projectDetails.issues.description',
    class: 'text description',
    width: '30%',
  },
  probability: {
    name: 'probability',
    field: 'probability',
    title: 'projectDetails.issues.probability',
    class: 'text probability',
    width: '10%',
    sortable: true,
  },
  severity: {
    name: 'severity',
    field: 'severity',
    title: 'projectDetails.issues.severity',
    class: 'text severity',
    width: '10%',
    sortable: true,
  },
  cvss: {
    name: 'cvss',
    field: 'cvss',
    title: 'projectDetails.issues.cvss',
    class: 'text cvss',
    width: '10%',
    sortable: true,
  },
  status: {
    name: 'status',
    field: 'status',
    title: 'projectDetails.issues.status',
    class: 'text status',
    width: '8%',
  },
  date: {
    name: 'date',
    field: 'date',
    title: 'projectDetails.issues.date',
    class: 'text date',
    width: '7%',
    minWidth: 150,
    sortable: true,
  },
};

export const advisedActionsColumns = {
  actionId: {
    name: 'actionId',
    field: 'id',
    title: 'actionsTable.id',
    class: 'text',
    width: '2%',
  },
  advisedAction: {
    name: 'advisedAction',
    field: 'advisedAction',
    title: 'actionsTable.advised.action',
    class: 'text',
    width: '30%',
  },
  domainAndAsset: {
    name: 'domainAndAsset',
    field: 'domainAndAsset',
    title: 'actionsTable.advised.domain.and.asset',
    class: 'text',
    width: '18%',
  },
  cycles: {
    name: 'cycles',
    field: 'cycles',
    title: 'issuesTable.cycles',
    class: 'text cycles',
    width: '5%',
  },
  firstSeen: {
    name: 'firstSeen',
    field: 'firstSeen',
    title: 'issuesTable.firstSeen',
    class: 'text firstSeen',
    width: '10%',
  },
  lastSeen: {
    name: 'lastSeen',
    field: 'lastSeen',
    title: 'issuesTable.lastSeen',
    class: 'text lastSeen',
    width: '10%',
  },
  impactScore: {
    name: 'impactScore',
    field: 'impactScore',
    title: 'actionsTable.impact.level',
    class: 'text',
    width: '12%',
    tooltip: 'actionsTable.tooltip.impactScore',
  },
  likelihoodAttack: {
    name: 'likelihoodAttack',
    field: 'likelihoodAttack',
    title: 'actionsTable.likelihood.attack',
    class: 'text',
    width: '13%',
    tooltip: 'actionsTable.tooltip.likelihoodAttack',
  },
  estimatedBreachCost: {
    name: 'estimatedBreachCost',
    field: 'estimatedBreachCost',
    title: 'EST. BREACH',
    class: 'text',
    width: '13%',
    tooltip: 'actionsTable.tooltip.estimatedBreachCost',
  },
  estimatedFixCost: {
    name: 'estimatedFixCost',
    field: 'estimatedFixCost',
    title: 'EST. COST',
    class: 'text',
    width: '13%',
    tooltip: 'actionsTable.tooltip.estimatedFixCost',
  },
  takeAction: {
    name: 'takeAction',
    field: 'takeAction',
    title: '',
    class: 'text',
    width: '0%',
  },
};
export const employeesColumns = {
  selected: {
    name: 'selected',
    field: 'selected',
    title: '',
    class: 'text',
    width: '4%',
  },
  employeeName: {
    name: 'name',
    field: 'name',
    title: 'NAME',
    class: 'text',
    width: '16%',
  },
  employeeEmail: {
    name: 'email',
    field: 'email',
    title: 'EMAIL',
    class: 'text',
    width: '20%',
  },
  employeeLeakDate: {
    name: 'leakDate',
    field: 'leakDate',
    title: 'LEAK_DATE',
    class: 'text',
    width: '10%',
  },
  employeeLeakSource: {
    name: 'leakSource',
    field: 'leakSource',
    title: 'LEAK_SOURCE',
    class: 'text',
    width: '20%',
  },
  employeePassword: {
    name: 'password',
    field: 'password',
    title: 'PASSWORD',
    class: 'text',
    width: '12%',
  },
  employeeUrl: {
    name: 'url',
    field: 'url',
    title: 'URL',
    class: 'text',
    width: '12%',
  },
  employeeSoftware: {
    name: 'software',
    field: 'software',
    title: 'SOFT',
    class: 'text',
    width: '12%',
  },
  authorized: {
    name: 'authorized',
    field: 'authorized',
    title: 'AUTHORIZED',
    class: 'text',
    width: '11%',
  },
};

export const getEmptyColumn = size => ({ width: `${size}px` });
